// Decimal odds — 3 fractional digits always. The 3rd decimal carries real
// signal in this domain (a 1.953 vs 1.95 mismatch can be the difference
// between "edge" and "no edge" against a target). Mono-spaced font keeps
// columns aligned across rows.
//   formatOdds(1.95)   → "1.950"
//   formatOdds(2.182)  → "2.182"
//   formatOdds(null)   → "—"
export function formatOdds(odds: number | null | undefined): string {
  if (odds === null || odds === undefined) return '—';
  return odds.toFixed(3);
}
